export default __webpack_public_path__ + "static/media/Chestguard of Indomitable Souls.6c71142e.jpg";